var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 25.618,
    height: 25.055,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734",
    transform: "translate(-36.248 -1072.248)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(39.248 1075.248)",
    fill: "#0d3b7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1726",
    "data-name": "Group 1726",
    transform: "translate(45.083 1081.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1725",
    "data-name": "Group 1725",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M25.618,4.811A4.813,4.813,0,0,0,20.807,0h-16A4.813,4.813,0,0,0,0,4.811V20.245a4.814,4.814,0,0,0,4.811,4.81h16a4.814,4.814,0,0,0,4.811-4.81Z",
    transform: "translate(0 -0.001)",
    fill: "#0c3b7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    "data-name": "Path 3101",
    d: "M708.926,634.294l-2.063,0v-2.467c0-.527.2-.8.656-.864h1.408a1.667,1.667,0,0,1,0,3.333Zm-2.063-6.655v-.649c0-.568.24-.839.768-.873h1.056a1.331,1.331,0,0,1,1.448,1.449,1.374,1.374,0,0,1-1.415,1.5h-1.857Zm4.7,2.462-.373-.21.326-.279a2.979,2.979,0,0,0,1.014-2.322c0-1.936-1.5-3.184-3.825-3.184H705.75a1.294,1.294,0,0,0-1.248,1.278v10.985h4.253c2.582,0,4.249-1.406,4.249-3.583a2.991,2.991,0,0,0-1.444-2.684",
    transform: "translate(-697.283 -617.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M1642.293,1526.117a1.513,1.513,0,1,1,1.511,1.518,1.514,1.514,0,0,1-1.511-1.518",
    transform: "translate(-1625.464 -1508.976)",
    fill: "#00bafc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    transform: "translate(36.248 1072.248)",
    fill: "none",
    stroke: "#0d3b7b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.3c10e633291e5aaf14635a22b5c74806.svg";
export { ForwardRef as ReactComponent };